/**
 * Maximum number of object keys shown in an inferred schema label.
 *
 * Why 6:
 * - 1-3 keys are often too little to identify DTOs with shared fields like `id`,
 *   `name`, or `createdAt`.
 * - More than ~6 keys makes console titles noisy, especially for large entity
 *   schemas such as games, orders, or users.
 * - The full schema is not meant to be reconstructed from the title; the title
 *   only needs to identify the likely contract before the detailed issues.
 *
 * Example:
 * `Object{id, name, description, gameId, alias, order, ...}`
 */
export const MAX_SCHEMA_KEYS_IN_LABEL = 6;

/**
 * Maximum number of values shown in compact validation summaries.
 *
 * Why 12:
 * - List responses can produce dozens or hundreds of repeated errors.
 * - Showing the first 12 indexes/fields is enough to reveal the pattern while
 *   keeping the console entry scannable.
 * - The raw `issues` array is still logged in full, so no diagnostic detail is
 *   lost when the summary is truncated.
 *
 * Example:
 * `affectedIndexes: [0, 1, 2, ..., 11, '+8 more']`
 */
export const MAX_SUMMARY_ITEMS = 12;
export const ZOD_PARSED_TYPE_LABELS = new Set([
  'array',
  'bigint',
  'boolean',
  'date',
  'float',
  'function',
  'integer',
  'map',
  'nan',
  'never',
  'null',
  'number',
  'object',
  'promise',
  'set',
  'string',
  'symbol',
  'undefined',
  'unknown',
  'void',
]);
